<template>
  <pt-business-order-lot-new class="pt-business-order-lot-new__page"></pt-business-order-lot-new>
</template>

<script>
import PtBusinessOrderLotNew from 'cps/sell-order/pt-business-order-lot-new/withData'
export default {
  name: 'pt-business-order-lot-new__view',
  components: {
    'pt-business-order-lot-new': PtBusinessOrderLotNew
  }
}
</script>
